// useFeatures.js
// Feature flags resolved from the backend (the single source of truth).
//
// Values default to OFF so gated features stay hidden until the backend
// confirms they are enabled — and stay hidden if the request fails (fail
// closed). The backend enforces the gate regardless (gated routes return 404);
// this only controls whether the UI surfaces the feature at all.

import { ref } from 'vue';
import http from '../http-common';

// Module-level singleton state shared across all callers.
// Rollout flag for the reworked native calendars. Default OFF → the SPA keeps
// rendering the existing @schedule-x calendars, so the new work is invisible in
// production and revertible by simply leaving the flag off.
const calendarV2Enabled = ref(false);
let loadPromise = null;

async function fetchFeatures() {
  try {
    const { data } = await http.get('/features');
    calendarV2Enabled.value = data?.calendarV2Enabled === true;
  } catch (e) {
    // Fail closed: keep gated features hidden if we can't reach the backend.
    calendarV2Enabled.value = false;
  }
}

/**
 * @returns {{
 *   calendarV2Enabled: import('vue').Ref<boolean>,
 *   ensureLoaded: () => Promise<void>
 * }}
 */
export function useFeatures() {
  // Kick off the fetch exactly once, lazily, on first use.
  if (!loadPromise) {
    loadPromise = fetchFeatures();
  }
  return { calendarV2Enabled, ensureLoaded: () => loadPromise };
}
